module.exports = __webpack_public_path__ + "static/media/chat.97b82c26.png";